import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Grid, Button, Radio } from 'semantic-ui-react';

import { DateForm, StatusList, SikdaeGroup, SikdaePolicy, SearchInputBox } from '../Commons';

import * as cm_action from 'actions/commons';

class SikdaeGivenForm extends Component {
  constructor() {
    super();
  }

  render() {
    const { sikdaeGroup, sikdaePolicy, sikStatus } = this.props,
      { sikdaeGroupSearch, sikdaeGroupVal, submitForm, handleEntSubmit, dateSearchType, handleDateSearchTypeChange } = this.props.formFn;

    return (
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Field>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}>
                  <Radio
                    label="신청일자로 검색"
                    name="dateSearchType"
                    value="REG"
                    checked={dateSearchType === 'REG'}
                    onChange={handleDateSearchTypeChange}
                    style={{
                      whiteSpace: 'nowrap',
                      minWidth: '120px',
                      marginRight: '10px'
                    }}
                  />
                  <Radio
                    label="지급/차감일자로 검색"
                    name="dateSearchType"
                    value="EXECUTE"
                    checked={dateSearchType === 'EXECUTE'}
                    onChange={handleDateSearchTypeChange}
                    style={{
                      whiteSpace: 'nowrap',
                      minWidth: '140px'
                    }}
                  />
                </div>
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={2} className="form-right">
              <Button color="black" inverted style={{ width: '100%' }} content="조회" onClick={submitForm} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group inline>
                <DateForm style={{ paddingLeft: 7 }} allowFutureDates={true} />
                <SearchInputBox
                  handleSubmit={submitForm}
                  handleEntSubmit={handleEntSubmit}
                  styles={{ marginLeft: 10 }}
                  placeHolder={'이름, 사유, 신청자'}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group style={{ marginBottom: 0 }}>
                <StatusList status={sikStatus} />
                <SikdaeGroup sikdaeGroup={sikdaeGroup} sikdaeGroupSearch={sikdaeGroupSearch} />
                <SikdaePolicy sikdaeGroupVal={sikdaeGroupVal} sikdaePolicy={sikdaePolicy} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

SikdaeGivenForm = connect((state) => ({
  sikdaeGroup: state.commons.sikdaeGroup,
  //groupIdx        : state.commons.group,

  sikdaePolicy: state.commons.sikdaePolicy,
  sikStatus: state.sikdae.sikdaeStatus
}))(SikdaeGivenForm);

export default SikdaeGivenForm;
